/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Item_Forked_FromInputs */



/**
* | output |
* | --- |
* | "Copy of “{name}”" |
*
* @param {Chat_Item_Forked_FromInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_item_forked_from = /** @type {((inputs: Chat_Item_Forked_FromInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Item_Forked_FromInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Kopie von „${i?.name}“`)
	return /** @type {LocalizedString} */ (`Copy of “${i?.name}”`)
});